var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u6D88\\u606F\\u7F3A\\u7701\\u56FE",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        opacity: 0.6;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-11, .cls-12, .cls-13, .cls-7 {\n        stroke: rgba(0,0,0,0);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-9 {\n        fill: none;\n      }\n\n      .cls-10 {\n        fill: #fefefe;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-13 {\n        opacity: 0.5;\n        fill: url(#linear-gradient-9);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_5413",
    "data-name": "\\u77E9\\u5F62 5413",
    className: "cls-1",
    width: 120,
    height: 120,
    transform: "translate(512 256)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdfe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#f1f3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.02,
    y1: -0.066,
    x2: 0.727,
    y2: 0.783,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edeef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.874,
    y1: -1.724,
    x2: -0.043,
    y2: 0.612,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.234,
    x2: 0.78,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.137,
    y1: 1.441,
    x2: 0.221,
    y2: 0.039,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8eaec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdfeff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.86,
    y1: 1.076,
    x2: -0.062,
    y2: -0.411,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0.127,
    x2: 1,
    y2: 0.94,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdd1d4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248\\u7EC4_638",
    "data-name": "\\u8499\\u7248\\u7EC4 638",
    className: "cls-2",
    transform: "translate(-512 -256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_11599",
    "data-name": "\\u7EC4 11599",
    transform: "translate(-4026.37 -1238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_8772",
    "data-name": "\\u7EC4 8772",
    className: "cls-3",
    transform: "translate(4543.37 1494.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706_550",
    "data-name": "\\u692D\\u5706 550",
    className: "cls-4",
    d: "M48.679,0A48.679,48.679,0,1,1,0,48.679,48.679,48.679,0,0,1,48.679,0Z",
    transform: "translate(6.321 20.562)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408_267",
    "data-name": "\\u8054\\u5408 267",
    className: "cls-5",
    d: "M3.247,11.843q-.1-.092-.193-.183A8.946,8.946,0,0,1,.025,4.932,6.8,6.8,0,0,1,1.319,0,5.861,5.861,0,0,0,3.583,3.674c1.68,1.3,5.9,1.383,8.317,1.45a5.64,5.64,0,0,1,3.747,1.682c1.037.948,2.139,2.289,2.746,2.874.811.779,3.435.921,4.278,1.808s.213,1.421-.338.98a4.947,4.947,0,0,0-5.5.128A12.2,12.2,0,0,1,10.1,14.612,10.346,10.346,0,0,1,3.247,11.843Z",
    transform: "translate(4542.676 1591.396) rotate(-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_985",
    "data-name": "\\u8DEF\\u5F84 985",
    className: "cls-6",
    d: "M168.544,279.78c-3.379,5.144-7.736,2.079-11.278,6.409s-3.919,5.943-8.6,7.148-7.421-2.878-7.421-2.878,4.554,12.031,16.416,12.031S169.127,289.881,168,286.749s1.249-5.973,1.817-6.612S169.746,278.143,168.544,279.78Z",
    transform: "translate(4487.432 1244.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_982",
    "data-name": "\\u8DEF\\u5F84 982",
    className: "cls-7",
    d: "M17.819,4.868c-3.572,1.28-4.579-1.845-7.932-1.025S5.755,5.312,3,4.169A4.4,4.4,0,0,1,.414,0s-2.221,7.613,3.62,12.014S14.36,10.06,14.968,8.1,17.8,5.623,18.318,5.516,19.019,4.507,17.819,4.868Z",
    transform: "translate(4560.184 1508.579) rotate(6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_17356",
    "data-name": "\\u7EC4 17356",
    transform: "translate(4068.013 -152.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_17358",
    "data-name": "\\u7EC4 17358",
    transform: "translate(505.083 1726.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_17357",
    "data-name": "\\u7EC4 17357",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10111",
    "data-name": "\\u8DEF\\u5F84 10111",
    className: "cls-9",
    d: "M570.014,1745.915l-17.965,7.233c1.936-.779,3.24-3.114,3.219-6.324l17.965-7.233C573.254,1742.8,571.949,1745.136,570.014,1745.915Z",
    transform: "translate(-516.665 -1739.591)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_17359",
    "data-name": "\\u7EC4 17359",
    transform: "translate(498.356 1684.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10112",
    "data-name": "\\u8DEF\\u5F84 10112",
    className: "cls-10",
    d: "M537.05,1698.11c3.521,1.282,6.437,6.22,6.472,10.969l.165,26.192c.03,4.747-2.837,7.58-6.358,6.3l-21.538-7.84-10.707,4.787-.055-8.7c-3.567-1.3-6.477-6.235-6.507-10.988l-.165-26.185c-.03-4.747,2.831-7.583,6.353-6.3Z",
    transform: "translate(-498.356 -1686.03)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408_399",
    "data-name": "\\u8054\\u5408 399",
    className: "cls-11",
    d: "M-17802.535,5552.035l-.16-26.194c-.037-4.747-2.951-9.682-6.473-10.968l-32.342-11.769a4.3,4.3,0,0,0-3.135-.027l15.768-6.355a4.3,4.3,0,0,1,3.135.022l32.34,11.773c3.521,1.28,6.434,6.212,6.475,10.956h0l.162,26.194c.021,3.207-1.285,5.544-3.215,6.323l-15.773,6.368C-17803.816,5557.579-17802.512,5555.246-17802.535,5552.035Z",
    transform: "translate(18346.219 -3818.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10114",
    "data-name": "\\u8DEF\\u5F84 10114",
    className: "cls-12",
    d: "M540.865,1730.027c1.87.681,3.377-.716,3.361-3.115s-1.547-4.9-3.416-5.583-3.376.716-3.361,3.115,1.547,4.9,3.416,5.583",
    transform: "translate(-8.433 -9.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10115",
    "data-name": "\\u8DEF\\u5F84 10115",
    className: "cls-12",
    d: "M526.349,1724.743c1.874.682,3.376-.716,3.361-3.115s-1.542-4.9-3.416-5.583-3.372.718-3.357,3.117,1.541,4.9,3.412,5.581",
    transform: "translate(-5.302 -8.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10116",
    "data-name": "\\u8DEF\\u5F84 10116",
    className: "cls-12",
    d: "M511.834,1719.461c1.871.681,3.372-.718,3.357-3.118s-1.541-4.9-3.411-5.58-3.377.716-3.362,3.115,1.547,4.9,3.416,5.583",
    transform: "translate(-2.17 -7.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10118",
    "data-name": "\\u8DEF\\u5F84 10118",
    className: "cls-13",
    d: "M513.025,1745.293l5.214,1.791-11.306,4.552Z",
    transform: "translate(-1.85 -15.108)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.e671a5dfa317541203fb4b4f5bbc212f.svg";
export { ForwardRef as ReactComponent };